module.exports = __webpack_public_path__ + "img/thai-map.e6689fc4.png";